import type { GetMatchesQuery, GetMatchesResponse } from '@clsplus/api-types/api-admin'

import { requestApiJsonOrThrow } from '../request-handler'

const GET_MATCHES_LIMIT = 50

function getMatches(query: GetMatchesQuery): Promise<GetMatchesResponse> {
  return requestApiJsonOrThrow<GetMatchesResponse>('admin/matches', {
    params: query,
  })
}

export const matchesQuery = (queryParams: GetMatchesQuery) => ({
  queryKey: ['matches', queryParams],
  queryFn: ({ pageParam = 0 }: { pageParam?: number }) =>
    getMatches({
      limit: GET_MATCHES_LIMIT.toString(),
      offset: pageParam.toString(),
      ...queryParams,
    }),
  getNextPageParam: (lastPage: GetMatchesResponse, pages: GetMatchesResponse[]) => {
    if (lastPage.data.length < GET_MATCHES_LIMIT) return
    return pages.length * GET_MATCHES_LIMIT
  },
})
